import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Svg from '@argos/svg'
import bem from '@argos/utils/esnext/bem'
import loading from './loading.svg'

import './loading-wheel.scss'

const cn = bem({ prefix: 'ac-', block: 'loading-wheel' })

class LoadingWheel extends Component {
  static propTypes = {
    contained: PropTypes.bool,
    noMask: PropTypes.bool,
    activeElement: PropTypes.object,
    returnFocus: PropTypes.bool,
  }

  static defaultProps = {
    contained: false,
    noMask: false,
    returnFocus: false,
  }

  constructor(props) {
    super(props)
    this.isElementToReturnFocus = null
  }

  componentDidMount() {
    this.isElementToReturnFocus = this.props.activeElement
  }

  componentWillUnmount() {
    if (!this.props.returnFocus) {
      return
    }

    setTimeout(() => {
      try {
        this.isElementToReturnFocus.focus()
        this.isElementToReturnFocus = null
      } catch (e) {
        this.isElementToReturnFocus = null
      }
    }, 0)
  }

  render() {
    const { contained, noMask, className } = this.props
    return (
      <div className={cn(null, { contained, 'no-mask': noMask }, className)} role='loading'>
        <div className={cn('icon')}>
          <p className='sr-only'>Loading</p>
          <Svg>{loading}</Svg>
        </div>
      </div>
    )
  }
}

export default LoadingWheel
